import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectCollisionDamageStep = (state) => state.get('collisionDamageStep');

const makeSelectCollisionDamageStep = () => createSelector(
  selectCollisionDamageStep,
  (stepCollisionDamageState) => ({
    areYouClaimingForRentalCarDamage: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'areYouClaimingForRentalCarDamage']),
      ''
    ),
    doYouHaveOtherTypeOfPetInsurance: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'doYouHaveOtherTypeOfPetInsurance']),
      ''
    ),
    schoolName: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'schoolName']),
      ''
    ),
    address: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'address']),
      ''
    ),
    cityOrTown: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'cityOrTown']),
      ''
    ),
    country: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'country']),
      ''
    ),
    postalCode: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'postalCode']),
      ''
    ),
    ifYesNameOfPhysicianCurrentlyTreatingThis: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'ifYesNameOfPhysicianCurrentlyTreatingThis']),
      ''
    ),
    contact: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'contact']),
      ''
    ),
    phoneNumber: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'phoneNumber']),
      ''
    ),
    companyNameForOther: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'companyNameForOther']),
      ''
    ),
    addressForOther: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'addressForOther']),
      ''
    ),
    typeOfPolicyForOther: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'typeOfPolicyForOther']),
      ''
    ),
    policyForOther: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'policyForOther']),
      ''
    ),
    contactForOther: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'contactForOther']),
      ''
    ),
    phoneForOther: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'phoneForOther']),
      ''
    ),
    origination: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'origination']),
      ''
    ),
    flightNumberOrigination: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'flightNumberOrigination']),
      ''
    ),
    airCarrierOrigination: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'airCarrierOrigination']),
      ''
    ),
    destination: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'destination']),
      ''
    ),
    nameOfTourOperatorOrCruiseOrLineOrAirline: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'nameOfTourOperatorOrCruiseOrLineOrAirline']),
      ''
    ),
    pleaseDescribeWhatOccurred: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'pleaseDescribeWhatOccurred']),
      ''
    ),
    dateOfLoss: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'dateOfLoss']),
      ''
    ),
    placeOfLoss: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'placeOfLoss']),
      ''
    ),
    flightNumberDestination: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'flightNumberDestination']),
      ''
    ),
    cityOrTownForOther: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'cityOrTownForOther']),
      ''
    ),
    countryForOther: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'countryForOther']),
      ''
    ),
    postalCodeForOther: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'postalCodeForOther']),
      ''
    ),
    airCarrierDestination: mapWithDefault(
      stepCollisionDamageState,
      () => stepCollisionDamageState.getIn(['form', 'airCarrierDestination']),
      ''
    ),
    expenseDescriptionOfItems: mapWithDefault(stepCollisionDamageState, () => stepCollisionDamageState.getIn(['form', 'expenseDescriptionOfItems']) && stepCollisionDamageState.getIn(['form', 'expenseDescriptionOfItems']).toJS(), ''),
  })
);

const makeSelectCollisionDamageStepErrors = () =>
  createSelector(selectCollisionDamageStep, (state) => state.get('errors'));

export {
  makeSelectCollisionDamageStep,
  makeSelectCollisionDamageStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.CollisionDamageStep/selectors.js